<template>
    <div class="grid-container">
        <div class="grid-x grid-margin-x">
            <div class="cell small-12 medium-5">
                <h3 class="case_title">{{ content.title }}</h3>
                <div class="case_images">
                    <div class="cell" v-for="(img, idx) in content.images" :key=idx>
                        <img :src="img.image">
                        <div class="fact" v-if="idx == 0 && content.sub_text.length > 1">
                            {{ content.sub_text }}
                        </div>
                    </div>
                    <div class="fact" v-if="content.images.length < 1">
                        {{ content.sub_text }}
                    </div>
                </div>
            </div>
            <div class="cell small-12 medium-7">
                <article v-if="content.text" v-html="content.text" class="case_content"></article>
                <router-link :to="`/poll?case=1`" class="button read_more">Узнать больше</router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Case",
    props: {
        content: {
            default: () => { return {} },
            required: true
        }
    },
    data: () => ({})
}
</script>

<style lang="scss">
    .case_title {
        font-family:$sans-serif; font-weight:900; font-size:fsz(3.5rem); line-height:1.1; margin-bottom:$space*4;
    }

    .case_images {
        img {
            display:block; margin-bottom:$space*4;
            &:last-child { margin-bottom:0 }
        }
    }

    .fact {
        border:1px solid #2d272f; padding:$space*1.5; font-family:$serif; text-align:right; margin-bottom:$space*4; position:relative; font-size:fsz(.9rem); width:90%;
        &:before {
            content:"Деталь"; position:absolute; top:-$space/1.3; right:$space*1.5; background:#fff; padding:0 $space; text-transform:uppercase; color:$brown; font-family:$sans-serif; font-weight:900; font-size:fsz(1rem)
        }
    }

    .case_content{
        font-family:$sans-serif;
        h3 { font-weight:900; font-family:$sans-serif; margin-top:$space; color:$brown }
        p + h3 { margin-top:$space*3 }
    }
</style>